<div class="Nav-Bar">
  <div class="Nav-Bar__Container">
    <div class="Nav-Bar__Container--Container-Logo">
      <div class="Nav-Bar__Container--Container-Logo--Logo">
        <img src="./assets/Global/Icon_SINCO.png" alt="">
      </div>
      <div class="Nav-Bar__Container--Container-Logo--Title">
        CDMS<span>Librerías</span>
      </div>
    </div>
    <div class="Nav-Bar__Container--InfoUser"></div>
  </div>
</div>

<div class="Body container-global-components">
  <div class="Body__Container">
    <div class="Body__Container--Image">
      <img src="./assets/Global/Ilustrations/Close-Sesion.png" alt="">
    </div>
    <div class="Body__Container--Title">
      Aviso de Sesión
    </div>
    <div class="Body__Container--Subtitle">
      Tu sesión ha sido cerrada o ha expirado por inactividad. Por favor, inicia sesión nuevamente para continuar.
    </div>
    <div class="Body__Container--Button">
      <button class="btn-icon-text" (click)="Reload()">
        <span class="text">Home</span><i class="fa-solid fa-house"></i>
      </button>
    </div>
  </div>
</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global active" id="Loader" *ngIf="isLoading">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>